// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__-Cqv8","rounded":"avatar_rounded__2DSNG"};